<template>
  <Transition name="cookie-slide">
    <div v-if="isVisible" class="cookie-consent">
      <div class="cookie-consent__content">
        <p class="cookie-consent__message">
          当サイトでは、利便性の向上やアクセス解析のためにCookieを使用しています。
          「同意する」をクリックすることでCookieの使用に同意したものとみなします。
        </p>
        <div class="cookie-consent__actions">
          <button class="btn btn-primary btn-sm" @click="accept">同意する</button>
          <button class="btn btn-outline-secondary btn-sm" @click="decline">拒否する</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

const STORAGE_KEY = "cookie_consent";
const isVisible = ref(false);

onMounted(() => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) {
    isVisible.value = true;
  }
});

const accept = () => {
  localStorage.setItem(STORAGE_KEY, "accepted");
  isVisible.value = false;
};

const decline = () => {
  localStorage.setItem(STORAGE_KEY, "declined");
  isVisible.value = false;
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: min(600px, calc(100vw - 40px));
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 16px 20px;
  z-index: 9999;
}

.cookie-consent__content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cookie-consent__message {
  flex: 1;
  margin: 0;
  font-size: 0.875rem;
  color: #495057;
  min-width: 200px;
}

.cookie-consent__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.cookie-slide-enter-active,
.cookie-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.cookie-slide-enter-from,
.cookie-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
